import { NavigationContext } from "context";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useNewNavigation = () =>
  useProviderInitializedContext(NavigationContext);
